<template>
  <div class="test">
    <div class="title">
      <el-input
        v-model="inputBoxList"
        @keyup.enter.native="getBoxList"
        ref="input"
      ></el-input>
      <el-button
        size="small"
        type="primary"
        @click="completeStock"
      >备货完成</el-button>
    </div>
    <div class="boxList">
      <div
        class="boxcodes"
        v-for="item in boxcodesList"
        :key="item.id"
        :class="{ active: selectBox(item.label) }"
        @click="addboxCode(item.label)"
      >{{item.label}}</div>
    </div>
    <!-- <img src="https://qr.api.cli.im/qr?data=RBAP1901050007-2-2&level=H&transparent=false&bgcolor=%23ffffff&forecolor=%23000000&blockpixel=12&marginblock=1&logourl=&size=260&kid=cliim&key=ac0ea35922bbc4296314eb12687e0606" /> -->
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectBoxList: [],
      inputBoxList: '',
      test: '',
      boxcodesList: [
        { label: 'R118121743654001' },
        { label: 'R118121743672001' }
        // { label: 'R118121743672001' },
        // { label: 'RBAP1901040005-4-1' },
        // { label: 'RBAP1901040005-4-2' },
        // { label: 'RBAP1901040005-4-3' },
        // { label: 'RBAP1901040005-4-4' },
        // { label: 'RBAP1901050001-1-1' },
        // { label: 'RBAP1901050002-2-1' },
        // { label: 'RBAP1901050002-2-2' }]
      ]
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$router.replace(from.path)
    })
  },
  mounted () {
    this.$refs['input'].focus()
    // this.$refs['input'].value = ''
  },
  computed: {
    selectBox () {
      return function (label) {
        return this.selectBoxList.filter(item => item === label).length !== 0
      }
    }
  },
  methods: {
    addboxCode (label) {
      if (this.selectBoxList.filter(item => item === label).length === 0) {
        this.selectBoxList.push(label)
      } else {
        this.selectBoxList.splice(this.selectBoxList.indexOf(label), 1)
      }
      this.$refs['input'].focus()
    },
    completeStock () {
      if (this.selectBoxList.length === 0) {
        this.$message.warning('未选择箱码')
      } else if (this.selectBoxList.filter(item => item === 'RBAP1901050007-2-1').length !== 0) {
        this.$message.error('RBAP1901050007-2-1不能备货完成')
      }
      this.$refs['input'].focus()
    },
    getBoxList () {
      if (this.selectBoxList.filter(item => item === this.inputBoxList).length === 0) {
        this.selectBoxList.push(this.inputBoxList)
      } else {
        this.$message.warning('已选择该箱码')
      }
      this.inputBoxList = ''
    }
  }
}
</script>

<style lang="scss">
.test {
  padding: 10px;
  .title {
    .el-button {
      margin-left: 40px;
    }
    .el-input {
      width: 200px;
    }
    .el-input__inner {
      height: 30px;
    }
  }
  .boxList {
    display: flex;
    flex-wrap: wrap;
    margin-top: 80px;
    width: 600px;
    .boxcodes {
      cursor: pointer;
      font-size: 14px;
      width: 160px;
      height: 30px;
      margin-top: 20px;
      margin-left: 10px;
      text-align: center;
      line-height: 30px;
      border: 1px solid #dcdfe6;
    }
    .boxcodes.active {
      background-color: #ff6224;
      color: #fff;
    }
  }
  img {
    position: fixed;
    left: 50%;
    // margin-left:100px;
    bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/test.vue